const FLAG = 'sokuzai_wake_beep';
let pending = false;

export function armWakeBeep() {
    try { sessionStorage.setItem(FLAG, '1'); } catch { /* ignore */ }
}

function beepSequence(ctx) {
    const notes = [[880, 0], [1175, 0.22], [1568, 0.44]];
    notes.forEach(([freq, delay]) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0.0001, ctx.currentTime + delay);
        gain.gain.exponentialRampToValueAtTime(0.4, ctx.currentTime + delay + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + delay + 0.18);
        osc.connect(gain).connect(ctx.destination);
        osc.start(ctx.currentTime + delay);
        osc.stop(ctx.currentTime + delay + 0.2);
    });
}

export function playReadyBeep() {
    try { navigator.vibrate?.([200, 100, 200, 100, 400]); } catch { /* ignore */ }
    try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return;
        const ctx = new Ctx();
        if (ctx.state === 'suspended') {
            // Autoplay bloqué : bip au tout premier toucher/clic de l'utilisateur
            const unlock = () => {
                ctx.resume().then(() => beepSequence(ctx));
                window.removeEventListener('touchstart', unlock);
                window.removeEventListener('click', unlock);
            };
            window.addEventListener('touchstart', unlock, { once: true });
            window.addEventListener('click', unlock, { once: true });
        } else {
            beepSequence(ctx);
        }
    } catch { /* ignore */ }
}

/** À appeler au montage de la page de login : bip (différé) si un réveil vient
 *  d'aboutir. Le drapeau n'est effacé qu'au moment où le signal est joué, pour
 *  survivre à une éventuelle navigation complète intermédiaire (ex: 401). */
export function checkWakeBeep(onReady) {
    try {
        if (!pending && sessionStorage.getItem(FLAG) === '1') {
            pending = true;
            setTimeout(() => {
                pending = false;
                try { sessionStorage.removeItem(FLAG); } catch { /* ignore */ }
                playReadyBeep();
                onReady?.();
            }, 600);
            return true;
        }
    } catch { /* ignore */ }
    return false;
}
